import { analytics } from 'analytics';
import Menu, { MenuItemProps } from 'ui/Menu';

const TrackedMenuItem: React.FC<MenuItemProps> = (props) => (
  <Menu.Item
    {...props}
    onClick={(e) => {
      analytics.track('Menu Item - Click', { id: props.value });
      props.onClick?.(e);
    }}
  />
);

export default TrackedMenuItem;
